<template>
  <button :disabled="isDisabled" :type="type" @click="onClick" :class="css">
    <slot>Submit</slot>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    isDisabled: false,
    onClick: {
      type: Function
      // required: true
    },
    theme: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'button'
    }
  },
  mounted () {
    // debugger
  },
  computed: {
    css () {
      if (this.theme === 'close') {
        return 'close'
      }
      return `btn btn-${this.theme}${this.size ? ` btn-${this.size}` : ''}`
    }
  }
}
</script>

<style lang="scss">
    @import "./button";
</style>



// WEBPACK FOOTER //
// src/components/Button/button.vue